import { createPinia } from 'pinia';

export const createPiniaInstance = () => {
  const pinia = createPinia();

  return pinia;
};
